'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProviderIntent = require('../components/ProviderIntent.js');

var _ProviderIntent2 = _interopRequireDefault(_ProviderIntent);

var _consts = require('../consts.js');

var _providerEvents = require('wix-art-store-3rd-party/dist/src/sdk/providerEvents');

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _WixSDKProviderApi = require('../components/WixSDKProviderApi');

var _WixSDKProviderApi2 = _interopRequireDefault(_WixSDKProviderApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutIntentOOI = function (_Component) {
  (0, _inherits3.default)(CheckoutIntentOOI, _Component);

  function CheckoutIntentOOI() {
    (0, _classCallCheck3.default)(this, CheckoutIntentOOI);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CheckoutIntentOOI.__proto__ || (0, _getPrototypeOf2.default)(CheckoutIntentOOI)).call(this));

    _this.handleCheckoutMessageReceived = _this.handleCheckoutMessageReceived.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CheckoutIntentOOI, [{
    key: 'handleCheckoutMessageReceived',
    value: function handleCheckoutMessageReceived(type, payload, resolve, reject, providerId) {
      var _props = this.props,
          artStoreApi = _props.artStoreApi,
          cartItems = _props.cartItems;

      switch (type) {
        case _providerEvents2.default.sdkReady:
          this.updateItems();
          break;
        case _providerEvents2.default.updateCartItem:
          // checkout cant update cart item
          // artStoreApi.updateCartItem({
          //   uuid: payload.uuid,
          //   metadata: payload.metadata,
          //   quantity: payload.quantity,
          // });
          break;
        case _providerEvents2.default.backHome:
          var openCart = payload && payload.openCart;
          this.props.onClose(openCart);
          break;
        case _providerEvents2.default.clearCart:
          artStoreApi.clearCart();
          break;
        case _providerEvents2.default.removeFromCart:
          artStoreApi.removeFromCart({ uuid: payload.uuid });
          break;
        case _providerEvents2.default.getCartItems:
          var items = cartItems || [];
          resolve(items);
          break;
        default:
          break;
      }
    }
  }, {
    key: 'updateItems',
    value: function updateItems() {
      if (this.intent) {
        var cartItems = this.props.cartItems;

        this.intent.postMessage(_providerEvents2.default.refreshCart, cartItems);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var cartItems = nextProps.cartItems;

      if (this.intent && cartItems) {
        var _cartItems = nextProps.cartItems;

        this.intent.postMessage(_providerEvents2.default.refreshCart, _cartItems);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          connectedProviders = _props2.connectedProviders,
          wixSdk = _props2.wixSdk,
          locale = _props2.locale,
          deviceType = _props2.deviceType,
          viewMode = _props2.viewMode,
          checkoutParams = _props2.checkoutParams,
          additionalProviderParams = _props2.additionalProviderParams;

      var customAdditionalParams = (0, _extends3.default)({}, checkoutParams);
      if (additionalProviderParams) {
        var srcId = additionalProviderParams.srcId,
            appDefId = additionalProviderParams.appDefId,
            isAlbumStore = additionalProviderParams.isAlbumStore;

        srcId && (customAdditionalParams.srcId = srcId);
        appDefId && (customAdditionalParams.appDefId = appDefId);
        isAlbumStore && (customAdditionalParams.isAlbumsStore = isAlbumStore);
      }
      var renderComponent = _react2.default.createElement(_ProviderIntent2.default, {
        api: new _WixSDKProviderApi2.default(wixSdk),
        hiddenFromEditor: true,
        ref: function ref(element) {
          return _this2.intent = element;
        },
        intent: _consts.providerIntents.checkout,
        onMessageReceived: this.handleCheckoutMessageReceived,
        additionalParams: {},
        customAdditionalParams: customAdditionalParams,
        connectedProviders: connectedProviders,
        locale: locale,
        deviceType: deviceType,
        viewMode: viewMode
      });
      return renderComponent;
    }
  }]);
  return CheckoutIntentOOI;
}(_react.Component); /* eslint-disable no-case-declarations */


exports.default = CheckoutIntentOOI;